import { Component, ViewEncapsulation, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * "Ready to go" rendered-share-image confirmation panel. Presentational — `sharing`
 * arrives as @Input(); download/share/cancel are @Output()s. Part of the dead share
 * chain (no in-app caller).
 */
@Component({
    selector: 'ft-share-image-created-ng',
    imports: [TranslateModule],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ft-share-image-created.component.html'
})
export class FtShareImageCreatedComponent {
    /** v1 `scope.sharing` — has `shareImageUrl` + `network`. */
    readonly sharing = input<any>();

    /** v1 `downloadShareImage(isStayOpen)` — the instructions link passes `true`, the
     * instagram Download button passes `false`. */
    readonly download = output<boolean>();
    /** v1 `openOAuth()` — the non-instagram Share button. */
    readonly share = output<void>();
    /** v1 `cancel()` — the ft-modal's own cancel (→ on-cancel="showCurationModal"). */
    readonly cancelClicked = output<void>();

    /** v1 `scope.isInstagram` — socialNetworkType 5. */
    protected isInstagram(network: any): boolean {
        return network && network.socialNetworkType == 5;
    }
}
